/* eslint-disable no-unused-vars */
import { Button, Table, message } from "antd";
import React, { useEffect, useState } from "react";
import API from "../../../../api";
import urls from "../../../../api/urls";
import Moment from "react-moment";
import "./style.scss";
import {
  capitaliseWithHyphen,
  normalizeService,
  serialNum,
} from "../../../../utils";
import moment from "moment";
import useCustomNavigate from "../../../../components/customNavigationHook";

const { GET_RECENT_BOOKING } = urls;

function RecentBooking({
  recentAPICall,
  bookingType,
  recentBookingsData,
  clientBooking = false,
  handleRecentBookingsData = () => {},
}) {
  const navigate = useCustomNavigate();
  // const customNavigate = useCustomNavigate();

  useEffect(() => {
    const company = JSON.parse(localStorage.getItem("selectedCompany")) || null;
    const clientCompanyId =
      JSON.parse(localStorage.getItem("userinfo")) || null;

    // if (clientBooking) {
    //   getRecentBooking(bookingType, clientCompanyId?.companyId);
    // } else {
    //   getRecentBooking(bookingType, company?.key);
    // }
  }, []);

  const getRecentBooking = async (type = "account", company) => {
    // setLoading(true);
    const response = await API.Api(
      GET_RECENT_BOOKING + type + `?branchId=${company}`
    ).getWithUserNPremiseHeader();

    if (response?.status) {
      handleRecentBookingsData(response?.response?.data);
      return;
    } else {
      handleRecentBookingsData([]);
      // message.error(
      //   response?.response?.data?.message || "Internal server error"
      // );
    }
  };

  function MyComponent(dateToFormat) {
    const formattedTime = moment(dateToFormat)?.format("DD/MM/YYYY");
    return formattedTime || "NA";
  }

  const columns = [
    {
      title: "SI",
      width: 50,
      dataIndex: "sl",

      render: (a, b, idx) => serialNum(10, 0, idx),
    },
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
      className: "awbNumber",
      defaultSortOrder: "descend",
      width: 110,
      //   render: (text, b) => <a onClick={() => handleEyeButton(b)}>{text} </a>,
    },
    {
      title: "Date",
      dataIndex: "bookingTime",
      key: "bookingTime",
      width: 80,
      render: (text, b) => MyComponent(text),
    },
    {
      title: (
        <>
          <span>
            Sender <br /> Name
          </span>
        </>
      ),
      dataIndex: "senderName",
      key: "senderName",
      width: 60,
      ellipsis: true,
      render: (text, b) => text || "NA",
    },

    {
      title: (
        <>
          <span>
            Booking <br /> Type
          </span>
        </>
      ),
      width: 60,
      dataIndex: "bookingType",
      key: "bookingType",
      //   render: (text) =>
      //     text?.toUpperCase() === "ACCOUNT" ? "Credit" : "Retail",
    },
    {
      title: (
        <>
          <span>
            Doc <br /> Type
          </span>
        </>
      ),
      width: 50,
      dataIndex: "type",
      key: "type",
      ellipsis: true,
      render: (text) => capitaliseWithHyphen(text),
    },
    {
      width: 110,
      title: (
        <>
          <span>
            Service <br /> Type
          </span>
        </>
      ),
      dataIndex: "serviceType",
      key: "serviceType",
      ellipsis: true,
      render: (text) => normalizeService(text),
    },
    {
      width: 60,
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      ellipsis: true,
      render: (text, val) => capitaliseWithHyphen(text),
    },
    {
      title: (
        <>
          <span>
            Receiver <br /> Name
          </span>
        </>
      ),
      dataIndex: "receiverName",
      key: "receiverName",
      ellipsis: true,
      // sorter: true,
      width: 80,
      // filters: shipmentMode,
      // filteredValue: filteredInfo?.travelBy || null,
      // filterMultiple: false,
      render: (text, val) => capitaliseWithHyphen(text) || "N/A",
    },
    {
      title: "To City",
      dataIndex: "toCenter",
      key: "toCenter",
      ellipsis: true,
      // sorter: true,

      width: 70,

      // filters: shipmentMode,
      // filteredValue: filteredInfo?.travelBy || null,

      // filterMultiple: false,
      render: (text, val) => capitaliseWithHyphen(text) || "N/A",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
      ellipsis: false,

      width: 60,

      // filters: shipmentMode,
      // filteredValue: filteredInfo?.travelBy || null,

      // filterMultiple: false,
      render: (text, val) => capitaliseWithHyphen(text) || "N/A",
    },
  ];

  return (
    <div className="recent-booking-container">
      <div className="space-between">
        <h4 className="ml-1" style={{ fontSize: "16px" }}>
          Recent bookings
        </h4>
        <Button
          style={{
            border: "none",
            color: "#2e77d0",
            fontSize: "16px",
            padding: "2px",
          }}
          onClick={() => {
            if (clientBooking) {
              navigate("/viewBooking");
            } else {
              if (bookingType == "Cash") {
                navigate("/viewBooking", { state: { currentTab: "2" } });
              } else {
                navigate("/viewBooking");
              }
            }
          }}
        >
          View all
        </Button>
      </div>
      {/* <h4 style={{ textAlign: "center" }}>
        Recent Booking list is down for sometime
      </h4> */}
      <Table
        dataSource={recentBookingsData?.length ? recentBookingsData : []}
        columns={columns}
        pagination={false}
        size="small"
      />
    </div>
  );
}

export default React.memo(RecentBooking);
